module.exports = __webpack_public_path__ + "static/media/Paypal.c6ecc710.png";